export default __webpack_public_path__ + "static/media/HideLogo.d9aa5e0c.png";